module.exports = __webpack_public_path__ + "static/media/sell_take_order_help_3.1138056b.jpg";